import Player from '@vimeo/player';

export default function() {

  let vimeoPlayer;

  return {
    playing: true,
    showControl: false,

    init() {
      const vimeoIframe = this.$el.querySelector('iframe[src^=https\\:\\/\\/player\\.vimeo]');
      const htmlVideo = this.$el.querySelector('video');

      if(vimeoIframe) {
        vimeoPlayer = new Player(vimeoIframe);
        vimeoPlayer.ready().then(() => {
          this.showControl = true;
          this.$watch('playing', val => {
            if (!val) {
              vimeoPlayer.pause();
            } else {
              vimeoPlayer.play();
            }
          });
        });
      }
      else if(htmlVideo) {
        this.showControl = true;
        this.$watch('playing', val => {
          if (!val) {
            htmlVideo.pause();
          } else {
            htmlVideo.play();
          }
        });
      }
    },
  };

}
